"use strict";

define('uikit/elements/header',['underscore', 'marionette', '../mixins/component.mixin', '../channel', '../templates', '../extra/size'], function (_, Mn, ComponentMixin, channel, Templates, Size) {
  var Header = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui header',
    template: Templates.UIKit['header'],
    options: {
      text: '',
      subText: '',
      icon: '',
      iconHeader: false,
      subHeader: false,
      dividing: false,
      block: false,
      attached: false,
      floated: false,
      aligned: false,
      inverted: false,
      color: false,
      muted: false,
      size: ''
    },
    sizeOptionValues: _.values(Size),
    update: {
      iconHeader: false,
      subHeader: false,
      dividing: false,
      block: false,
      attached: false,
      floated: false,
      aligned: false,
      inverted: false,
      color: false,
      size: false,
      muted: false
    },
    updateAttributes: function updateAttributes() {
      var attached = this.getOption('attached'),
        floated = this.getOption('floated'),
        aligned = this.getOption('aligned');
      this.addClass('icon', this.getBoolOption('iconHeader')).addClass('dividing', this.getBoolOption('dividing')).addClass('block', this.getBoolOption('block')).addClass('sub', this.getBoolOption('subHeader')).addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached')).addClass(floated + ' floated', this.getBoolOption('floated')).addClass(aligned + ' aligned', this.getBoolOption('aligned')).addClass('inverted', this.getBoolOption('inverted')).addClass(this.getOption('color'), this.getBoolOption('color')).addClass(this.getOption('size'), this.getBoolOption('size')).addClass('muted', this.getBoolOption('muted'));
    }
  });
  channel.reply('header', function () {
    return Header;
  });
  return Header;
});

